import { render, staticRenderFns } from "./reversement.vue?vue&type=template&id=ca87e370&scoped=true"
import script from "./reversement.vue?vue&type=script&lang=js"
export * from "./reversement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca87e370",
  null
  
)

export default component.exports